import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  gap: ${props => props.theme.spacing.sp8};
  padding: ${props => props.theme.spacing.sp4} ${props => props.theme.spacing.sp16};
  background-color: ${props => props.theme.colors.warning.surface};
  color: ${props => props.theme.colors.warning.onSurface};
`
